import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';

import i18next from 'i18next';

import { DistributorPrice } from 'types/api/distributor.type';

import { distributorDataService } from 'services/distributor.service';

import { BucketContext, S3Item } from 'contexts';

import { checkParams } from 'helpers/checkParams';

import { Input } from 'components/Input';

const useItem = (props: DistributorPrice, season: string, zone: string) => {
  const { getUrl } = useContext(BucketContext);

  const {
    register,
    watch,
    formState: { errors },
  } = useForm({ mode: 'onChange' });

  const prices = Object.values(watch()).map((item) => item || '0.0');

  const [image, imageSet] = useState<string>('');

  const {
    genderCode,
    genderDescription,
    itemColorCode,
    englishColorColorDescription,
    italianColorColorDescription,
    itemCode,
    mainFabricCode,
    mainFabricDesc,
    fieldOneDisabled,
    fieldTwoDisabled,
    fieldThreeDisabled,
    fieldFourDisabled,
    pricePosOne,
    pricePosTwo,
    pricePosThree,
    pricePosFour,
    imageName,
  } = props;

  const inputsData = [
    {
      label: 'pos 1',
      name: 'pos1',
      isDisabled: fieldOneDisabled,
      value: pricePosOne !== '0.0' ? pricePosOne : '',
    },
    {
      label: 'pos 2',
      name: 'pos2',
      isDisabled: fieldTwoDisabled,
      value: pricePosTwo !== '0.0' ? pricePosTwo : '',
    },
    {
      label: 'pos 3',
      name: 'pos3',
      isDisabled: fieldThreeDisabled,
      value: pricePosThree !== '0.0' ? pricePosThree : '',
    },
    {
      label: 'pos 4',
      name: 'pos4',
      isDisabled: fieldFourDisabled,
      value: pricePosFour !== '0.0' ? pricePosFour : '',
    },
  ];

  const infoPrimary = genderDescription;
  const infoSecondary = `${genderCode} ${itemCode} ${mainFabricCode} ${mainFabricDesc}`;
  const infoTertiary = `* ${itemColorCode} ${
    i18next.language === 'en' ? englishColorColorDescription : italianColorColorDescription
  } `;

  const changePrice = () => {
    const data = {
      season,
      zone,
      itemCode,
      mainFabricCode,
      genderCode,
      prices,
    };

    if (checkParams(data)) {
      distributorDataService.putPrice(data).then(() => {
        toast.success('Price successfully changed');
      });
    }
  };

  const inputsComponent = inputsData.map((item) => (
    <Input
      type="number"
      motive="filter"
      defaultValue={item.value}
      key={item.name}
      name={item.name}
      register={register}
      error={errors && errors[item?.name]?.message}
      label={item.label}
      disabled={item.isDisabled}
      placeholder="Inserisci prezzo"
      options={{
        min: {
          value: 0,
          message: 'Minimal value is 0',
        },
        max: {
          value: 9999,
          message: 'Maximal value is 9999',
        },
      }}
      onBlur={() => {
        changePrice();
      }}
    />
  ));

  useEffect(() => {
    if (!imageName) return;

    getUrl(`catalogue/products${imageName}`).then((res: S3Item) => {
      imageSet(res.url);
    });
  }, [imageName]);

  return {
    inputsComponent,
    infoPrimary,
    infoSecondary,
    infoTertiary,
    image,
  };
};

export { useItem };
